(ns ui.modal)

(defn modal-panel
  "The box takes the full width up to `sm:max-w-5xl`; a modal that wants a
   smaller box passes a Tailwind max-width class as the `:max-width` param
   of `:ui/modal-open`."
  [state]
  [:div.flex.min-h-full.items-end.justify-center.p-4.text-center
   {:class ["sm:items-center" "sm:p-0"]}

   [:div.relative.transform.overflow-hidden.rounded-lg.bg-gray-50.px-4.pb-4.pt-5.text-left.shadow-xl.transition-all
    {:class ["sm:my-8" "sm:w-full" "sm:p-6"
             (or (get-in state [:ui/modal :params :max-width])
                 "sm:max-w-5xl")]
     :style {:overflow "visible"}
     ;:on {:click (fn [event] (.stopPropagation event))}
     }

    ;; Above the modal's content, which may be positioned itself (a
    ;; `relative` root) and would cover the button otherwise.
    [:div.absolute.right-0.top-0.z-20.pr-4.pt-4
     [:button.rounded-md.bg-gray-50.text-gray-400
      {:type "button"
       :class ["hover:text-gray-500"
               "focus:outline-none"
               "focus:ring-2"
               "focus:ring-indigo-500"
               "focus:ring-offset-2"]
       :on {:click [[:ui/modal-close]]}
       }
      [:span.sr-only "Close"]
      [:svg.size-6 {:fill "none"
                    :viewBox "0 0 24 24"
                    :stroke-width "1.5"
                    :stroke "currentColor"
                    :aria-hidden "true"
                    :data-slot "icon"}
       [:path {:stroke-linecap "round"
               :stroke-linejoin "round"
               :d "M6 18 18 6M6 6l12 12"}]]]]

    (when-let [render (get-in state [:ui/modal :render])]
      (render state))]])

(defn render
  [state]
  (when (:ui/modal state)
    [:div.relative
     {:role "dialog"
      :style {:z-index 101}}
     [:div.fixed.inset-0.transition-opacity
      {:class ["bg-gray-800/75"]}]
     [:div.fixed.inset-0.z-10.w-screen.overflow-y-auto
      #_{:on {:click [[:ui/modal-close]]}}
      (modal-panel state)
      ]]))
